import { ContextsSymbol } from '../index';
import { type Action, type ActionWithContexts, type Contexts } from '../types';

const isActionWithContexts = (action: Action | ActionWithContexts): action is ActionWithContexts =>
	!!(action as unknown as ActionWithContexts)?.[ContextsSymbol];

export const extractContextsFromAction = <A extends Action>(
	action: A,
): Partial<Contexts> | undefined =>
	isActionWithContexts(action) ? action[ContextsSymbol] : undefined;
